<section class="messages-skeleton">
    <!-- messages skeleton loader -->
<div class="messages-skeleton__sender">
  <ngx-skeleton-loader [count]="1" [theme]="{
    'border-radius': '1em 1em 0 1em',
    width: '10em',
    height: '3em',
    backgroundColor: '#00a65114',
  }"></ngx-skeleton-loader>
    <ngx-skeleton-loader [count]="1" [theme]="{
      'border-radius': '1em 1em 0 1em',
      width: '20em',
      height: '3em',
      backgroundColor: '#00a65114',
    }"></ngx-skeleton-loader>
</div>

<div>
  <ngx-skeleton-loader [count]="1"  [theme]="{
    'border-radius': '1em 1em 1em 0em',
    width: '20em',
    height: '6em',
    backgroundColor: '#00a65114',
  }"></ngx-skeleton-loader>
</div>

<div class="messages-skeleton__sender">
  <ngx-skeleton-loader [count]="1" [theme]="{
    'border-radius': '1em 1em 0 1em',
    width: '10em',
    height: '3em',
    backgroundColor: '#00a65114',
  }"></ngx-skeleton-loader>
</div>
<div>
  <ngx-skeleton-loader [count]="1" [theme]="{
    'border-radius': '1em 1em 1em 0em',
    width: '20em',
    height: '3em',
    backgroundColor: '#00a65114',
  }"></ngx-skeleton-loader>
</div>

</section>